(function () {
  'use strict';

  function getPageFromUrl(url) {
    const match = url.match(/[?&]page=(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function buildPageUrl(page) {
    const params = new URLSearchParams(window.location.search);
    if (page <= 1) {
      params.delete('page');
    } else {
      params.set('page', page);
    }
    const qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function findNextUrl() {
    const currentPage = getPageFromUrl(window.location.href) || 1;
    const allLinks = document.querySelectorAll('.pagination__item[href]');
    for (const link of allLinks) {
      if (getPageFromUrl(link.href) === currentPage + 1) {
        return link.href;
      }
    }
    return null;
  }

  class InfiniteScroll {
    constructor() {
      this.productGrid = document.getElementById('product-grid');
      this.container   = document.getElementById('ProductGridContainer');
      this.pagination  = document.querySelector('.pagination-wrapper');

      if (!this.productGrid || !this.container) return;

      this.nextUrl     = findNextUrl();
      this.isLoading   = false;
      this.scrollBound = this._onScroll.bind(this);

      console.log('[IS] nextUrl found:', this.nextUrl);

      if (!this.nextUrl) {
        console.log('[IS] No next page found, stopping.');
        return;
      }

      if (this.pagination) this.pagination.style.display = 'none';

      this._createLoader();
      this._attachSentinel();
      window.addEventListener('scroll', this.scrollBound, { passive: true });
    }

    _createLoader() {
      const existing = document.getElementById('is-loader');
      if (existing) existing.remove();

      const loader = document.createElement('div');
      loader.id = 'is-loader';
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-label', 'Loading more products');
      loader.style.cssText = 'display:none;justify-content:center;align-items:center;padding:40px 0;width:100%;';
      loader.innerHTML = `
        <style>
          .is-spinner {
            width:32px;height:32px;
            border:3px solid rgba(0,0,0,0.1);
            border-top-color:#333;
            border-radius:50%;
            animation:is-spin 0.7s linear infinite;
          }
          @keyframes is-spin { to { transform:rotate(360deg); } }
        </style>
        <div class="is-spinner"></div>
      `;
      this.container.appendChild(loader);
      this.loader = loader;
    }

    _attachSentinel() {
    const existing = document.getElementById('is-sentinel');
    if (existing) existing.remove();

    this.sentinel = document.createElement('div');
    this.sentinel.id = 'is-sentinel';
    this.sentinel.setAttribute('aria-hidden', 'true');
    this.sentinel.style.cssText = 'height:10px;width:100%;display:block;clear:both;background:transparent;';

    // Place it inside the collection div, after the product grid ul
    const collection = this.container.querySelector('.collection');
    if (collection) {
        collection.appendChild(this.sentinel);
    } else {
        this.container.appendChild(this.sentinel);
    }

    console.log('[IS] Sentinel rect after attach:', this.sentinel.getBoundingClientRect());

    this.observer = new IntersectionObserver(
        (entries) => {
        console.log('[IS] Observer fired:', entries[0].isIntersecting, entries[0].boundingClientRect);
        if (entries[0].isIntersecting && !this.isLoading && this.nextUrl) {
            this._loadMore();
        }
        },
        { root: null, rootMargin: '300px', threshold: 0 }
    );

    this.observer.observe(this.sentinel);
    }

    _onScroll() {
      const markers = document.querySelectorAll('[data-is-page-marker]');
      if (!markers.length) return;

      let activePage = getPageFromUrl(window.location.href) || 1;

      markers.forEach((marker) => {
        const rect = marker.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.5) {
          activePage = parseInt(marker.dataset.isPageMarker, 10);
        }
      });

      const newUrl = buildPageUrl(activePage);
      if (window.location.href !== newUrl) {
        history.replaceState({ isPage: activePage }, '', newUrl);
      }
    }

    async _loadMore() {
      this.isLoading = true;
      this.loader.style.display = 'flex';
      console.log('[IS] Loading:', this.nextUrl);

      try {
        const response = await fetch(this.nextUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html     = await response.text();
        const doc      = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid .grid__item');

        console.log('[IS] Items found in fetched page:', newItems.length);

        if (!newItems.length) {
          this._finish();
          return;
        }

        const loadedPage = getPageFromUrl(this.nextUrl);

        // Page boundary marker for URL sync
        const marker = document.createElement('div');
        marker.dataset.isPageMarker = loadedPage;
        marker.setAttribute('aria-hidden', 'true');
        marker.style.cssText = 'height:0;overflow:hidden;';
        this.productGrid.appendChild(marker);

        // Append new cards into the grid
        newItems.forEach((item) => {
          item.classList.remove('scroll-trigger--cancel');
          this.productGrid.appendChild(item);
        });

        // Find next URL from fetched page
        const currentPage = loadedPage;
        const fetchedLinks = doc.querySelectorAll('.pagination__item[href]');
        let nextUrl = null;
        fetchedLinks.forEach((link) => {
          if (getPageFromUrl(link.href) === currentPage + 1) {
            nextUrl = link.href;
          }
        });

        this.nextUrl = nextUrl;
        console.log('[IS] Next URL after load:', this.nextUrl);

        if (!this.nextUrl) this._finish();

      } catch (err) {
        console.error('[IS] Fetch failed:', err);
        if (this.pagination) this.pagination.style.display = '';
      } finally {
        this.isLoading = false;
        this.loader.style.display = 'none';
      }
    }

    _finish() {
        if (this.observer) this.observer.disconnect();
        this.loader.style.display = 'none';
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.scrollBound);
      ['is-sentinel', 'is-loader'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    }
  }

  // ─── Boot ───────────────────────────────────────────────────────────────────

  let instance = null;

  function boot() {
    if (instance) instance.destroy();
    instance = new InfiniteScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Reinit after facets.js replaces grid
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(() => {
      if (!document.getElementById('is-sentinel')) {
        const pag = document.querySelector('.pagination-wrapper');
        if (pag) pag.style.display = '';
        boot();
      }
    }).observe(gridContainer, { childList: true });
  }

})();